// Stripped header for standalone landing pages: the logo, centered, and nothing
// else. No nav, no CTA, no drawer — every one of those is an exit from a page
// whose only job is the booking form. The logo is deliberately NOT a link for
// the same reason.
export default function LandingHeader() {
  return (
    <div className="aehome ae-contents">
      <header className="lphead">
        <div className="lphead__container">
          <img
            src="/images/logo.webp"
            alt="Account Editor"
            className="lphead__logo"
            width="180"
            height="40"
          />
        </div>
      </header>
    </div>
  );
}
